// extracted by mini-css-extract-plugin
module.exports = {"notSupportedLink":"video_notSupportedLink__MHp3J","text":"video_text__3vemJ"};